import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./PersonalDetailsForm.css";
import { useDispatch, useSelector } from "react-redux";
import FormInputStyle2 from "../../../../components/Form/FormInputStyle2";
import FormSelectStyle2 from "../../../../components/Form/FormSelectStyle2";
import FormButtonStyle2 from "../../../../components/Form/FormButtonStyle2";
import moment from "moment";
import { toast } from "react-toastify";
import callApi from "../../../../utility/apiCaller";
import { setUserClickData } from "../../../../utility/setUserClickData";
import { useNavigate } from "react-router-dom";
import { login } from "../../../../store/app/appReducer";
import OTPInput from "react-otp-input";
import FormInputStyle4 from "../../../DMIFinance/UIElements/FormInput";
import { TRACK_ID } from "../../../../utility/enum";
import { getAllianceLeadFromMoneyTapInput } from "../../../../utility/commonUtils";
import { setLead } from "../../../../store/app/appReducer";


const PersonalDetailsForm = ({
  isFormStarted,
  setIsFormStarted,
  currentStep,
  setCurrentStep,
  formData,
  setFormData,
}) => {
  const [gender, setGender] = useState("");
  const [name, setName] = useState("");
  const [dob, setDob] = useState("");
  const [email, setEmail] = useState("");
  const [pincode, setPincode] = useState("");
  const [professionType, setprofessionType] = useState("");
  const [mobile, setMobile] = useState("");
  const [isMobileValid, setIsMobileValid] = useState(true);
  const [source, setSource] = useState("");
  const [utmSource, setUtmSource] = useState("");
  const [utmTerm, setUtmTerm] = useState("");
  const [affId, setAffId] = useState("");
  const [params] = useSearchParams();
  const [errors, setErrors] = useState({});
  const [pancard, setPan] = useState("");
  const [isPanValid, setIsPanValid] = useState(true);
  const [isConsentChecked, setIsConsentChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOtpGenerated, setIsOtpGenerated] = useState(false);
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { lenderName, lenderId } = useSelector((state) => state.app.lead);
  const [isFocused, setIsFocused] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
    const user = useSelector((state) => state.app.user);
  const [pincodeValidation, setpincodeValidation] = useState(false);

  useEffect(() => {
    if (params.get("source")) setSource(params.get("source"));
    if (params.get("utm_source")) setUtmSource(params.get("utm_source"));
    if (params.get("aff_id")) setAffId(params.get("aff_id"));
    if (params.get("utm_term")) setUtmTerm(params.get("utm_term"));
  }, [params]);

  useEffect(() => {
    const container = document.getElementById("personal-loan-form");
    if (container)
      container.resetOtpState = () => {
        setIsOtpGenerated(false);
        setOtp("");
      };
  }, []);

  const handleMobileChange = (event) => {
    let value = event.target.value;

    // Remove any non-digit characters
    value = value.replace(/\D/g, "");

    // Limit to 10 digits
    if (value.length > 10) {
      value = value.slice(0, 10);
    }

    // Allow only if first digit is 6, 7, 8, or 9 (if length >= 1)
    if (value.length === 0 || /^[6-9]/.test(value)) {
      setMobile(value);
      setFormData((prev) => ({
        ...prev,
        mobile: value,
      }));

      // Validate: length must be exactly 10 and no digit repeats more than 8 times consecutively
      const hasInvalidRepetition = /(.)\1{8,}/.test(value); // matches any digit repeated 9 or more times

      setIsMobileValid(value.length === 10 && !hasInvalidRepetition);
    }
  };

  const handlePanChange = (e) => {
    const value = e.target.value.toUpperCase();
    setPan(value);
    const isValid = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value);

    if (value.length === 10) {
      setIsPanValid(isValid);
    } else {
      setIsPanValid(true);
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!gender) newErrors.gender = true;
    if (!name.trim()) newErrors.name = true;
    if (!dob.trim()) newErrors.dob = true;
    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) newErrors.email = true;
    if (!pincode.match(/^\d{6}$/)) newErrors.pincode = true;
    if (!professionType) newErrors.professionType = true;

    // PAN validation logic
    if (!pancard || !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pancard)) {
      newErrors.pancard = true;
      setIsPanValid(false);
    } else {
      setIsPanValid(true);
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  console.log("Personal formData:", formData);

  useEffect(() => {
    const allValid =
      gender &&
      name.trim() &&
      dob.trim() &&
      email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/) &&
      pincode.match(/^\d{6}$/) &&
      professionType &&
      pancard;

    setIsFormValid(allValid);
  }, [gender, name, dob, email, pincode, professionType, pancard, isPanValid]);

  useEffect(() => {
    if (formData) {
      setGender(formData.gender || "");
      setName(formData.name || "");
      setMobile(formData.mobile || "");
      setPan(formData.pancard || "");
      setDob(formData.dob || "");
      setEmail(formData.email || "");
      setPincode(formData.pincode || "");
      setprofessionType(formData.professionType || "");
    }
  }, []);

  const handleConsentChange = () => {
    setIsConsentChecked((prev) => !prev);
  };

  const handleNameChange = (e) => {
    let newName = e.target.value;

    // Remove any character that is not a letter or space
    newName = newName.replace(/[^A-Za-z\s]/g, "");

    // Replace multiple spaces with a single space
    newName = newName.replace(/\s+/g, " ");

    setName(newName);

    // Validate: name must have at least 2 characters after trimming
    setErrors((prev) => ({
      ...prev,
      name: newName.trim().length < 2,
    }));
  };

  const MIN_DATE = new Date("1900-01-01");
  const MAX_DATE = new Date(); // today

  const handleDateChange = (e) => {
    let input = e.target.value.replace(/\D/g, ""); // keep only digits

    // Auto insert slashes
    if (input.length > 2) input = input.slice(0, 2) + "/" + input.slice(2);
    if (input.length > 5) input = input.slice(0, 5) + "/" + input.slice(5, 9);
    if (input.length > 10) input = input.slice(0, 10);

    setDob(input);

    // Only validate when we have full length (DD/MM/YYYY)
    if (input.length === 10) {
      const isValid = validateDate(input, MIN_DATE, MAX_DATE);
      console.log(isValid);
      if (!isValid.ok) {
        setErrors((prev) => ({
          ...prev,
          dob: isValid.error, // ✅ true if invalid
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          dob: false, // ✅ true if invalid
        }));
      }
    } else {
      setErrors((prev) => ({
        ...prev,
        dob: true, // incomplete or invalid format
      }));
    }
  };

  function validateDate(dateStr, minDate, maxDate) {
    const [dd, mm, yyyy] = dateStr.split("/").map(Number);

    if (!dd || !mm || !yyyy)
      return { ok: false, error: "Incomplete date format" };

    if (mm < 1 || mm > 12)
      return { ok: false, error: "Month must be between 1 and 12" };

    // Days per month (leap year considered)
    const daysInMonth = new Date(yyyy, mm, 0).getDate();
    if (dd < 1 || dd > daysInMonth)
      return { ok: false, error: "Invalid day for given month" };

    // Build Date object safely
    const parsed = new Date(
      `${yyyy}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`
    );

    // Check for impossible dates like 00/00/0000 or invalid parsing
    if (isNaN(parsed.getTime())) return { ok: false, error: "Invalid date" };

    // Range check
    if (parsed < minDate)
      return { ok: false, error: `Date must be after ${formatDate(minDate)}` };
    if (parsed > maxDate)
      return { ok: false, error: `Date must be before ${formatDate(maxDate)}` };

    return { ok: true };
  }

  function formatDate(date) {
    return date.toISOString().slice(0, 10).split("-").reverse().join("/");
  }

  const handlePincodeChange = async (value) => {
    value = value.replace(/\D/g, ""); // allow only digits

    if (/^\d{0,6}$/.test(value)) {
      // Prevent first digit being 0 if there's at least one digit
      if (value.length > 0 && value[0] === "0") {
        return; // ignore input if first digit is 0
      }

      setPincode(value); // always update input field

      // clear error if user is still typing
      if (errors.pincode) {
        setErrors((prev) => ({ ...prev, pincode: false }));
      }

      // Only validate when user has entered 6 digits
      if (value.length === 6) {
        setpincodeValidation(true); // start loading state

        try {
          // ✅ call your backend API using callApi instead of fetch
          const response = await callApi(
            `v1/util/${value}`, // backend route
            "get", // HTTP method
            {}, // body (not needed for GET)
            "core" // service key
          );

          if (!response.success) {
            setErrors((prev) => ({ ...prev, pincode: true }));
          } else {
            setErrors((prev) => ({ ...prev, pincode: false }));

            console.log("Valid Pincode, City:", response.city);
          }
        } catch (error) {
          console.error("Pincode validation error:", error);
          setErrors((prev) => ({ ...prev, pincode: true }));
        } finally {
          setpincodeValidation(false); // end loading state
        }
      }
    }
  };

  function isValidEmail(email) {
    if (typeof email !== "string") return false;

    // Step 1: Trim and normalize input
    const cleaned = email.trim().toLowerCase();

    // Step 2: Reject dangerous characters or encoded attacks
    // Prevent encoded XSS attempts like "%3Cscript%3E"
    if (/[<>]/.test(cleaned)) return false;
    if (/%3C|%3E|script|onerror|onload/i.test(cleaned)) return false;

    // Step 3: Strict regex for email validation (RFC 5322 simplified)
    const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!EMAIL_REGEX.test(cleaned)) return false;

    // Step 4: Optional: length checks
    if (cleaned.length > 254) return false;

    return true;
  }

  const handleValidation = () => {
    let isValid = true;
    if (!validate()) return;
    if (!/^\d{10}$/.test(mobile) || mobile.length !== 10) {
      isValid = false;
      setIsMobileValid(false);
    } else {
      setIsMobileValid(true);
    }

    return isValid;
  };

  const handleValidateAndUpdateForm = async () => {
    // Step 1: Validate form
    if (!handleValidation()) {
      return;
    }

    // Step 2: Check consent
    if (!isConsentChecked) {
      toast.error("Please agree to the Terms and Conditions.");
      return;
    }

    // Step 2a: Track user click
    setUserClickData({
      event_name: "personal-details-form-submit-pl-non-pan",
      utm_source: utmSource ,
      user_id: formData.mobile || "No User ID found here",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
    });

    // Step 3: Update form data locally
    setFormData((prev) => ({
      ...prev,
      gender,
      pancard,
      name,
      email,
      pincode,
      professionType,
      dob,
      mobile,
      mobiletncchecked: true,
      mobiletnctime: new Date().toISOString(),
    }));

    try {
      const trackId = localStorage.getItem(TRACK_ID);

      // Prepare lead payload
      const processedLead = getAllianceLeadFromMoneyTapInput(
        "website-pl-non-pan",
        {
          gender,
          pancard,
          name,
          email,
          pincode,
          professionType,
          dob,
          mobile,
          mobiletncchecked: true,
          mobiletnctime: new Date().toISOString(),
          ...user,
        }
      );

      console.log("Processed Lead: ", processedLead);

      // API call to save/update lead
      const res = await callApi(
        "v1/lead/finbud-lp-lead",
        "post",
        {
          lead: {
            ...processedLead,
            tracking_id: trackId,
            aff_id: params.get("aff_id"),
            utm_source: params.get("utm_source"),
            source: params.get("source"),
            utm_medium: params.get("utm_medium"),
            utm_term: params.get("utm_term"),
            is_stage1_completed: true,
            steps_completed: 2,
          },
        },
        "core",
        user.token
      );
      console.log(res);

      if (res?.status === "Success") {
        toast.success("Form data updated successfully");
        dispatch(setLead(res?.data));
        // Step 5: Move to next step ONLY on successful API response
        setCurrentStep((prev) => prev + 1);
      } else {
        toast.error(res?.message || "Failed to update form data");
      }
    } catch (error) {
      console.error("Error updating lead:", error);
      toast.error("Something went wrong while updating form data");
    }
  };

  return (
    <div className="personal-details-container-v3">
      <h2 className="form-title-v3">Personal information</h2>
      <p className="form-subtitle-v3">
        We will use your contact details to proceed further.
      </p>
      <input type="hidden" name="utm_campaign" value="" />
      <input type="hidden" name="utm_source" value={utmSource || ""} />
      <input type="hidden" name="utm_medium" value="" />
      <input type="hidden" name="utm_content" value="" />
      <input type="hidden" name="click_id" value="" />
      <input type="hidden" name="aff_id" value={affId || ""} />
      <input type="hidden" name="src" value={source || ""} />

      <div className="personal-details-input">
        <div className="gender-toggle-v3">
          <button
            className={`gender-btn-v3 ${gender === "Male" ? "active" : ""}`}
            onClick={() => setGender("Male")}
          >
            <div className="gender-content-v3">
              <img
                src={
                  gender === "Male"
                    ? "/assets/img/Male_green.svg"
                    : "/assets/img/Male_black.svg"
                }
                alt="Male Icon"
              />
              <span>Male</span>
            </div>
          </button>
          <button
            className={`gender-btn-v3 ${gender === "Female" ? "active" : ""}`}
            onClick={() => setGender("Female")}
          >
            <div className="gender-content-v3">
              <img
                src={
                  gender === "Female"
                    ? "/assets/img/Female_green.svg"
                    : "/assets/img/Female_black.svg"
                }
                alt="Female Icon"
              />
              <span>Female</span>
            </div>
          </button>
        </div>

        <FormInputStyle2
          label="Full Name as per Pan Card"
          value={name}
          onChange={handleNameChange}
          isValid={!errors.name}
          errorMessage="Name is required"
        />
        <FormInputStyle2
          label="Mobile Number"
          value={mobile}
          isValid={showErrors ? isMobileValid : true}
          minLength="10"
          maxLength="10"
          pattern="[0-9]{10}"
          inputMode="numeric"
          onChange={handleMobileChange}
          errorMessage="Mobile Number is required"
        />
        <FormInputStyle2
          type="text"
          name="pancard"
          isValid={isPanValid}
          id="pancard"
          minLength="10"
          maxLength="10"
          value={pancard}
          onChange={handlePanChange}
          required
          label={"PAN Number"}
          inputMode="text"
          errorMessage={"Please enter a valid PAN Number"}
        />
        <FormInputStyle2
          label="Date of Birth"
          value={dob}
          onChange={handleDateChange}
          isValid={!errors.dob}
          errorMessage={errors.dob ? errors.dob : "DOB is required"}
          placeholder={dob ? "" : "DD/MM/YYYY"}
          maxLength={10}
          labelClassName="dob-label"
        />
        <FormInputStyle2
          label="Personal Email Address"
          value={email}
          onChange={(e) => {
            const value = e.target.value;
            setEmail(value);

            const valid = isValidEmail(value);

            setErrors((prev) => ({
              ...prev,
              email: !valid, // true = invalid, false = valid
            }));
          }}
          onBlur={() => {
            if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
              setErrors((prev) => ({ ...prev, email: true }));
            }
          }}
          isValid={!errors.email}
          errorMessage="Enter a valid email"
        />

        <FormInputStyle4
          label="Home Pin Code"
          value={pincode}
          onChange={(e) => handlePincodeChange(e.target.value)}
          onBlur={() => {
            if (!/^\d{6}$/.test(pincode) || errors.pincode) {
              setErrors((prev) => ({ ...prev, pincode: true }));
            }
          }}
          isValid={!errors.pincode}
          errorMessage="Enter a valid 6-digit PIN"
          tick={pincode.length === 6 && !errors.pincode}
          loading={pincodeValidation}
        />

        <FormSelectStyle2
          label="Occupation"
          value={professionType}
          onChange={(val) => {
            setprofessionType(val);
            if (errors.professionType) {
              setErrors((prev) => ({ ...prev, professionType: false }));
            }
          }}
          onBlur={() => {
            if (!professionType) {
              setErrors((prev) => ({ ...prev, professionType: true }));
            }
          }}
          options={[
            { label: "Salaried", value: "Salaried" },
            { label: "Self-Employed", value: "Self-Employed" },
            { label: "Business Owner", value: "business owner" },
          ]}
          isValid={!errors.professionType}
          errorMessage="Please select professionType"
        />
      </div>

      <div className="checkbox-wrapper-v3">
        <input
          type="checkbox"
          id="consent"
          checked={isConsentChecked}
          onChange={handleConsentChange}
        />
        <label htmlFor="consent" className="consent">
          I have read and agreed to the{" "}
          <a className="anc-font" href="https://digitmoney.in/terms">
            Terms of Use
          </a>{" "}
          and hereby appoint DigitMoney and its{" "}
          <a className="anc-font" href="https://digitmoney.in/lenders">
            Lending Partners
          </a>{" "}
          to receive my credit information from credit bureaus. By submitting my
          details I override my NDNC registration & authorize DigitMoney and its{" "}
          <a className="anc-font" href="https://digitmoney.in/lenders">
            Lending Partners
          </a>{" "}
          / representatives to contact me through Call, SMS, Email, Whatsapp or
          any other mode. You also authorize us to send you promotional offers
          of financial & non-financial products or services from time to time.
        </label>
      </div>

      <FormButtonStyle2
        text="Continue"
        onClick={handleValidateAndUpdateForm}
        disabled={mobile.length !== 10 || isLoading || !isFormValid}
        id="btn-personal-details-landing-v4"
        className="tracking-btn-personal-details-landing-v4"
      />
    </div>
  );
};

export default PersonalDetailsForm;
